export default class AttachmentUploadRequestError extends Error {

}